import { createHttpHeaderWithAuthorization } from "../../../services/http-header";
import { callWithRetry } from "../../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../../config";

export const ledgerConstants = {
  GET_ENTRIES_READ_START: "GET_ENTRIES_READ_START",
  GET_ENTRIES_READ_SUCCESS: "GET_ENTRIES_READ_SUCCESS",
  GET_ENTRIES_READ_ERROR: "GET_ENTRIES_READ_ERROR",

  CLEAR_ENTRIES_PARAMETERS: "CLEAR_ENTRIES_PARAMETERS"
};

export function clearEntriesParameters() {
  return dispatch => {
    dispatch({
      type: ledgerConstants.CLEAR_ENTRIES_PARAMETERS
    });
  };
}

export function getEntriesRead(
  accountId,
  accountName,
  fromDate,
  toDate
) {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    return new Promise((resolve, reject) => {
      const parameters = {
        accountId: accountId,
        accountName: accountName,
        fromDate: fromDate,
        toDate: toDate,
        model: "balance"
      };

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/ledger/items/entries?accountId=${encodeURIComponent(accountId)}&itemId=${itemId}&managerId=${managerId}${fromDate ? "&fromDate=" + fromDate : ""}${toDate ? "&toDate="+toDate : ""}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: ledgerConstants.GET_ENTRIES_READ_START,
        payload: { parameters: parameters }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: ledgerConstants.GET_ENTRIES_READ_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: ledgerConstants.GET_ENTRIES_READ_ERROR,
              error: { error: result, parameters: parameters }
            });
            reject();
          }
        })
        .catch(response => {
          dispatch({
            type: ledgerConstants.GET_ENTRIES_READ_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
